import { useEffect, useRef, useState } from 'react'
import { Option } from 'types/option'

export const useLargeListFilterOptions = ({
  isOpen,
  options,
  selectedValues,
}: {
  isOpen: boolean
  options: Option[]
  selectedValues: string[]
}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const wasOpen = useRef(false)
  const lastSearch = useRef('')
  const [filteredOptions, setFilteredOptions] = useState<Option[]>([])
  useEffect(() => {
    const dropDownOpened = isOpen && !wasOpen.current
    const dropDownClosed = !isOpen && wasOpen.current
    const searchTermChanged = searchTerm !== lastSearch.current

    if (dropDownOpened || searchTermChanged) {
      const { selected, unselected } = options
        .filter(option =>
          option.name.toLowerCase().includes(searchTerm.toLowerCase()),
        )
        .reduce<{ selected: Option[]; unselected: Option[] }>(
          ({ selected, unselected }, option) => {
            if (selectedValues.some(id => id === option.id)) {
              selected.push(option)
            } else {
              unselected.push(option)
            }
            return { selected, unselected }
          },
          { selected: [], unselected: [] },
        )

      setFilteredOptions([...selected, ...unselected])
    }

    if (dropDownClosed) {
      setSearchTerm('')
    }

    wasOpen.current = isOpen
    lastSearch.current = searchTerm
  }, [
    isOpen,
    wasOpen.current,
    options,
    selectedValues,
    searchTerm,
    lastSearch.current,
  ])

  return { filteredOptions, searchTerm, setSearchTerm }
}
